const substituteEncodedCharacters = require('./substituteEncodedCharacters')
const substituteEncodedCarets = require('./substituteEncodedCarets')

function getCharactersAndExtensions (script, mode) {
  const characters = []
  const extensions = []
  const isProse = mode === 'PROSE_TO_FDX'

  if (script.length === 0) return { characters, extensions }

  script.forEach(token => {
    if (token.type === 'character') {
      token.text = (isProse && token.content) ? token.content[0].text : token.text
      // another guard against empty prose content
      if (token.text) {
        const divided = token.text.split('(')
        const char = substituteEncodedCarets(divided[0].trim())
        const extension = divided[1] && `(${divided[1]}`
        // in prose scripts carets arent encoded by this method because the XML is built up incrementally
        characters.push(substituteEncodedCharacters(char, mode))
        if (extension) extensions.push(extension)
      }
    }
  })
  return {
    characters: Array.from(new Set(characters)),
    extensions: Array.from(new Set(extensions))
  }
}

function getLocationsAndTimes (script, mode) {
  const locations = []
  const times = []
  const isProse = mode === 'PROSE_TO_FDX'

  if (script.length === 0) return { locations, times }

  script.forEach(token => {
    if (token.type === 'scene_heading' || token.type.toLowerCase() === 'sceneheading') {
      token.text = (isProse && token.content) ? token.content[0].text : token.text
      // another malformed prose content guard
      if (token.text) {
        const divided = token.text.split('-')
        let time
        let [, ...location] = divided[0].split(' ')
        if (location) location = substituteEncodedCarets(location.join(' ').trim())
        const timeExists = !!divided[1]
        if (timeExists) {
          time = divided[1].trim()
          times.push(substituteEncodedCharacters(time, mode))
        }
        // in prose scripts carets arent encoded by this method because the XML is built up incrementally
        locations.push(substituteEncodedCharacters(location, mode))
      }
    }
  })

  return {
    locations: Array.from(new Set(locations)),
    times: Array.from(new Set(times))
  }
}

function getTransitions (script, mode) {
  const transitions = []
  const isProse = mode === 'PROSE_TO_FDX'

  script.forEach(token => {
    if (token.type === 'transition') {
      transitions.push((isProse && token.content) ? token.content[0].text : token.text)
    }
  })
  return { transitions }
}

// massage prose documents into a flat array of blocks from each individual page
function flattenScript (script) {
  const flattenedProseContent = []
  // first we loop through each page of the script. take your dramamine. this is the first of many.
  script.content.forEach(page => {
    if (page.attrs && !page.attrs.dynamic) {
      // a manual page break means that the first snippet of content needs to go on a fresh page
      page.content[0].startsNewPage = true
    }
    // next we loop through each content block on each page
    page.content.forEach(block => {
      // if dual dialogue is encountered, you guessed it, a few more loops are needed
      if (block.type === 'dual_dialogue') {
        // first we insert the same marker as fountain uses
        flattenedProseContent.push({ type: 'dual_dialogue_begin' })
        // next we loop through each of the two columns to dig out their character names, dialogue (and perhaps parentheticals)
        block.content.forEach(column => {
          column.content.forEach(ddBlock => {
            flattenedProseContent.push(ddBlock)
          })
        })
        // then we insert another marker to let the parser know we're out of dd zone.
        flattenedProseContent.push({ type: 'dual_dialogue_end' })
      } else {
        // normal blocks need to be appended too
        flattenedProseContent.push(block)
      }
    })
  })
  return flattenedProseContent
}

module.exports = {
  getCharactersAndExtensions,
  getLocationsAndTimes,
  getTransitions,
  flattenScript
}
